var map = {
	"./404.svg": "a14a",
	"./Inquiry-line.svg": "c15d",
	"./Logistics.svg": "7187",
	"./all-line.svg": "3cd1",
	"./bug.svg": "1779",
	"./car.svg": "ec2f",
	"./caveat-line.svg": "fc0b",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./confirm-line.svg": "591d",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./finance-line.svg": "c078",
	"./financial.svg": "fef9",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./help-line.svg": "128a",
	"./helpcenter.svg": "54f2",
	"./helpcenter2.svg": "63fb",
	"./icon.svg": "9d91",
	"./inquire2.svg": "cf26",
	"./international.svg": "17df",
	"./landing.svg": "e2ed",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money-red.svg": "feb5",
	"./money.svg": "3046",
	"./msg-line.svg": "c991",
	"./nested.svg": "dcf8",
	"./order-err.svg": "724c",
	"./order-line.svg": "66d4",
	"./order-success.svg": "df8c",
	"./order.svg": "11ff",
	"./out-of-stock.svg": "f42a",
	"./package-line.svg": "e7c9",
	"./package.svg": "f5e6",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./return.svg": "3488",
	"./search.svg": "8e8d",
	"./send-out.svg": "123a",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./std-enquiry.svg": "3646",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./truck-line.svg": "ecd5",
	"./user-line.svg": "bc18",
	"./user.svg": "b3b5",
	"./user2.svg": "1976",
	"./warehouse-line.svg": "ccd5",
	"./waybill.svg": "9240",
	"./waybill2.svg": "9196",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";